<script lang="ts">
  import { is } from '@shared/utils';

  export let activeId: number;
  export let id: number;
  export let classes: string = '';
</script>

<div class="{is(activeId === id, 'block', 'hidden')} {classes}">
  <slot />
</div>
